<template>
  <div class="legal-agreement-wrapper" v-if="isEsignActive">
    <!-- Main Legal Agreement Modal -->
    <b-modal v-model="showModel" size="lg" id="legalAgreementModal" hide-header hide-footer scrollable
      :no-close-on-backdrop="true" :no-close-on-esc="true" style="font-size: 20px;">
      <div class="text-center mt-2 mb-4">
        <h2>Legal Agreement</h2>
      </div>

      <div class="legal-agreement-content p-3" v-html="sanitizedLegalAgreementContent" @scroll.passive="onScroll"
        ref="scrollContainer" style="height: 300px; overflow-y: auto; border: 1px solid #ccc;"></div>

      <div class="info-box p-3 mt-3 text-center" style="background: #e3eaf3; border-top: 1px solid #ccc;">
        <p><strong>As per SEBI regulations, Aadhaar-based e-signature is required to avail our services. Please complete
            the e-sign process to proceed.</strong></p>
        <b-button class="eSign-btn" variant="primary" @click="openEsign" :disabled="!hasScrolledToBottom || isLoading">
          <span v-if="isLoading">
            <b-spinner small class="mr-2"></b-spinner> Loading...
          </span>
          <span v-else>
            Sign
          </span>
        </b-button>
         <p>
          Please read till the bottom of the legal agreement to activate the Sign button</p>
      </div>
    </b-modal>

    <!-- Aadhaar E-sign Iframe Modal -->
    <b-modal v-model="showIframe" size="xl" id="esignModal" hide-header hide-footer :no-close-on-backdrop="true"
  :no-close-on-esc="true">
      <div class="text-center my-3" v-if="isIframeLoading">
        <b-spinner label="Loading iframe..."></b-spinner>
        <p>Loading e-Sign document...</p>
      </div>

      <iframe v-if="esignIframeSrc" :src="esignIframeSrc" width="100%" height="600px" frameborder="0"
        style="margin-top: 20px;" @load="isIframeLoading = false" v-show="!isIframeLoading"></iframe>
    </b-modal>
  </div>
</template>


<script>
import axios from 'axios';
import { fixLegalAgreementHtml } from '@/utils/fixLegalAgreementHtml'

const plainAxios = axios.create();

export default {
  name: "legalagreementpostpayment",

  props: {
  legalAgreementContent: {
    type: String,
    required: true
  },
  esignData: {
    type: Object,
    default: () => ({})
  },
  isEsignActive: {
      type: Boolean,
      required: true
  }
},

  computed: {
    sanitizedLegalAgreementContent () {
      return fixLegalAgreementHtml(this.legalAgreementContent)
    }
  },

  data() {
    return {
      showModel: true,
      checkboxVal: false,
      booleanValue: false,
      esignIframeSrc: null,
      showIframe: false,
      isEsignOpen: false,
      isLoading: false,
      isIframeLoading: true,
      hasScrolledToBottom: false

    }
  },
 mounted() {
  window.addEventListener('message', this.handleEsignComplete, false);
},
beforeDestroy() {
  window.removeEventListener('message', this.handleEsignComplete);
},
  methods: {
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (!this.hasScrolledToBottom && scrollTop + clientHeight >= scrollHeight - 150) {
          this.hasScrolledToBottom = true;
      }
    },
    handleEsignComplete(event) {
    if (event?.data?.type === 'E_SIGN_COMPLETE') {
      this.showIframe = false;
      this.$notify({
        group: 'allAlerts',
        title: '',
        type: 'success',
        text: `
          <div class="notificationBox">
            <span class="notificationIcon">
              <i class="font16 weight-500 pr-2 fa-check-circle fa" aria-hidden="true"></i>
            </span>
            <span class="notificationText">E-sign completed successfully!</span>
          </div>`
      });
    }
  },
    check(e) {
      this.booleanValue = e.target.checked;
    },
    notifyParent() {
      window.parent.postMessage({ type: 'E_SIGN_COMPLETE' }, '*');
    },
    async openEsign() {
      if (!this.hasScrolledToBottom) {
        this.$notify({
          group: 'allAlerts',
          title: '',
          type: 'error',
          text: `
        <div class="notificationBox">
          <span class="notificationIcon">
            <i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i>
          </span>
          <span class="notificationText">Please read the agreement</span>
        </div>`
        });
        return;
      }
      this.isLoading = true;

      try {
        const esignId = this.esignData?.id;
        if (!esignId) throw new Error('Missing esign ID from prop');
        var userEmail = this.$store.state.authentication.user.email;
        var name = this.$store.state.authentication.user.name;
        var mobile = this.$store.state.authentication.user.phoneNumber;
        const payload = {
          name: name,
          document_name: ".pdf",
          email: userEmail,
          mobile: mobile,
          reason: "PortfolioSmith India Subscription",
          days_to_expire:"7",
          productCode: "PSI",
          esignId: esignId
        };

        const response = await plainAxios.post("https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/vendor/e-sign", payload, {
        });

        if (response.data.status == 200) {
          const htmlContent = response.data.data.token;
          await this.getEsignLink(htmlContent);
          this.showModel = false;
          this.showIframe = true;

        }

      } catch (error) {
        this.$notify({
          group: 'allAlerts',
          title: '',
          type: 'error',
          text: `
        <div class="notificationBox">
          <span class="notificationIcon">
            <i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i>
          </span>
          <span class="notificationText">Failed to initiate e-sign process</span>
        </div>`
        });
      }
      finally {
        this.isLoading = false;
      }
    },

    async getEsignLink(uuid) {
      try {
        const url = `https://esign.meon.co.in/EsignServices/eSign/${uuid}`;
        this.isIframeLoading = true;
        this.esignIframeSrc = url;
        this.showIframe = true;

      } catch (error) {
        throw error;
      }
    }
  }
}
</script>
<style scoped>
.eSign-btn:disabled,
.eSign-btn.disabled,
.eSign-btn[disabled] {
  background-color: #9ec9ff !important; 
  border-color:     #9ec9ff !important;
  color: #fff !important;                
  opacity: 1 !important;                  
  cursor: not-allowed;
}

.legal-agreement-content {
  max-height: 300px;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/legalagreementpostpayment.vue